import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["contentId", "contentType", "onSuccess"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setSuccessAlert, setAlert } from 'actions/alerts';
import { playlistQueryKeys } from 'actions/playlists';
import { assetQueryKeys } from 'actions/assets';
import commentKeys from './queryKeys';
function useDeleteComment(_ref) {
  var contentId = _ref.contentId,
    _ref$contentType = _ref.contentType,
    contentType = _ref$contentType === void 0 ? 'asset' : _ref$contentType,
    _onSuccess = _ref.onSuccess,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function deleteComment(_x) {
    return _deleteComment.apply(this, arguments);
  }
  function _deleteComment() {
    _deleteComment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('delete', "/api/me/content/".concat(contentId, "/comments/").concat(id), null));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _deleteComment.apply(this, arguments);
  }
  var _useMutation = useMutation(deleteComment, _objectSpread(_objectSpread({}, options), {}, {
      onSuccess: function onSuccess() {
        _onSuccess === null || _onSuccess === void 0 ? void 0 : _onSuccess();
        setSuccessAlert({
          title: t('alert_comment_deleted_success')
        });
        return Promise.all([queryClient.invalidateQueries(commentKeys.contentComments(contentId)), queryClient.invalidateQueries(contentType === 'playlist' ? playlistQueryKeys.singlePlaylist(contentId) : assetQueryKeys.singleAsset(contentId)), queryClient.invalidateQueries(contentType === 'playlist' ? playlistQueryKeys.allPlaylistAnalytics : assetQueryKeys.allAssetAnalytics)]);
      },
      onError: function onError() {
        setAlert({
          title: t('alert_comment_deleted_error')
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    deleteComment: mutateAsync
  });
}
export default useDeleteComment;